export const faIconDragAndDropClassName = 'fa-icon-drag-and-drop';
